// DrawerItem/DrawerItem.jsx
import  { useState, useEffect } from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
  Tooltip,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../Context/AuthProvider";
import { useGetLogout } from "../../../Components/Login/Hooks";
import { useTranslation } from "react-i18next";

function DrawerItem({ item, selected, setSelected, sidebar, iconMap }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const newOpr = useAuth();
  const { mutate } = useGetLogout();
  const { t } = useTranslation('sidebar');
  const title = t(item.key);

  const hasChildren = item.children && item.children.length > 0;
  const icon =
    item.icon && iconMap[item.icon] ? iconMap[item.icon] : item.icon || null;
  const isActive = Boolean(item.to) && location.pathname === item.to;

  // اگه یکی از فرزندها انتخاب شده باشه، خودکار باز بمونه
  useEffect(() => {
    if (!hasChildren) return;
    const childTitles = item.children.map((c) => c.title);
    if (childTitles.includes(selected)) {
      setOpen(true);
    }
  }, [selected, hasChildren, item.children]);

  const handleClick = async () => {
    if (hasChildren) {
      if (!sidebar) return; // وقتی سایدبار بسته‌ست، submenu باز نشه
      setOpen((prev) => !prev);
      return;
    }

    setSelected(item.title);
    if (item.title === "خروج") {
      newOpr.logout();
      await mutate();
      return;
    }
    if (item.to) navigate(item.to);
  };

  const buttonContent = (
    <ListItemButton
      onClick={handleClick}
      selected={!hasChildren && isActive}
      sx={[
        {
          // minHeight: 44,
          px: item.smallpadding ? 1.2 : 2.5,
          borderRadius: "8px",
          mx: 0.5,
          mb: 0.3,
          // color: "rgba(34, 3, 3, 0.96)",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.10)" },
          "&.Mui-selected": {
            backgroundColor: "rgba(255,255,255,0.18)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
          },
        },
        sidebar ? { justifyContent: "initial" } : { justifyContent: "center" },
      ]}
    >
      {icon && (
        <ListItemIcon
          sx={[
            { minWidth: 0, justifyContent: "center", color: "inherit" },
            sidebar ? { mr: 3 } : { mr: "auto" },
          ]}
        >
          {icon}
        </ListItemIcon>
      )}

      <ListItemText
        primary={title}
        primaryTypographyProps={{
          fontFamily: "yekan",
          fontWeight: isActive ? 700 : 500,
          fontSize: "14px",
          noWrap: true,
          color:'white'
        }}
        sx={[sidebar ? { opacity: 1 } : { opacity: 0 }]}
      />

      
      {hasChildren && sidebar && (open ? <ExpandLessIcon fontSize="small" sx={{color:'white'}} /> : <ExpandMoreIcon fontSize="small" sx={{color:'white'}} />)}
    </ListItemButton>
  );

  return (
    <>
      <ListItem disablePadding sx={{ display: "block" }}>
        {!sidebar ? (
          <Tooltip title={title} placement="right" arrow>
            {buttonContent}
          </Tooltip>
        ) : (
          buttonContent
        )}
      </ListItem>

      {/* رندر بازگشتی فرزندها، فقط وقتی هم children داره هم سایدبار بازه */}
      {hasChildren && sidebar && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ paddingInlineStart: "1rem" }}>
            {item.children.map((child) => (
              <DrawerItem
                key={child.key}
                item={child}
                selected={selected}
                setSelected={setSelected}
                sidebar={sidebar}
                iconMap={iconMap}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

export default DrawerItem;